import { CircularProgress, Stack } from '@mui/material'

export const LoadingState = () => {
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      paddingY={5}
      width="100%"
    >
      <CircularProgress />
    </Stack>
  )
}
